import React from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * KpiBar — bandeau de KPIs en FILETS (pas de boîtes), extrait du Dashboard.
 * Chiffres serif tabular-nums, eyebrows espacés, séparateurs hairline. Remplace les
 * rangées de cartes-stats encadrées et génériques des pages internes.
 *
 * items : [{ label, value, sub?, onClick?, isText? }]
 *  - value : déjà formatée (string ou number). isText=true → taille réduite (montants).
 *  - onClick : rend l'item cliquable (chevron au survol).
 */
export default function KpiBar({ items = [] }) {
  const n = items.length;
  const cols = n >= 4 ? 'grid-cols-2 xl:grid-cols-4' : n === 3 ? 'grid-cols-1 sm:grid-cols-3' : 'grid-cols-1 sm:grid-cols-2';
  return (
    <div
      className={`grid ${cols} mb-8`}
      style={{ borderTop: '1px solid var(--border-soft)', borderBottom: '1px solid var(--border-color)' }}
      data-testid="kpi-bar"
    >
      {items.map((k, i) => {
        const Tag = k.onClick ? 'button' : 'div';
        return (
          <Tag
            key={i}
            onClick={k.onClick}
            className={`group text-left py-6 pr-5 pl-5 first:pl-0 transition-colors duration-200 ${k.onClick ? 'cursor-pointer hover:bg-[var(--bg-tertiary)]' : ''}`}
            style={{ borderRight: i < n - 1 ? '1px solid var(--border-color)' : 'none' }}
          >
            <div className="flex items-center justify-between">
              <span className="text-[10.5px] uppercase tracking-[0.16em]" style={{ color: 'var(--text-tertiary)' }}>{k.label}</span>
              {k.onClick && <ChevronRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200" style={{ color: 'var(--text-tertiary)' }} />}
            </div>
            <div className="font-serif tabular-nums mt-3.5 leading-none" style={{ fontSize: k.isText ? 20 : 34, fontWeight: 400, letterSpacing: '-0.02em', color: 'var(--text-primary)' }}>
              {k.value}
            </div>
            {k.sub && <div className="text-[11.5px] mt-3" style={{ color: 'var(--text-tertiary)' }}>{k.sub}</div>}
          </Tag>
        );
      })}
    </div>
  );
}
